import React, { memo } from "react";
import classnames from "classnames";
import Element from "src/components/base/element";
interface IProps {
    className?: string;
    children: React.ReactNode;
}

function MediaContent(props: IProps) {
    const { className, children, ...rest } = props;
    return (
        <Element
            {...rest}
            className={classnames(
                className,
                "media-content",
                "basis-auto grow shrink text-left self-center w-0"
            )}
        >
            {children}
        </Element>
    );
}

export default memo(MediaContent);
